import { render, staticRenderFns } from "./ekko.button-download.vue?vue&type=template&id=2be79750&scoped=true&"
import script from "./ekko.button-download.vue?vue&type=script&lang=ts&"
export * from "./ekko.button-download.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.button-download.vue?vue&type=style&index=0&id=2be79750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be79750",
  null
  
)

export default component.exports